import { CalendarOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import dayjs from 'dayjs';
import { get } from 'lodash';
import React from 'react';
import { getWidgetPath } from '../../../../../validator/form-builder/getWidgetPath';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { DateRangeRule } from '../../../../rules/repository/date-range/DateRange.rule';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import { DateWidgetComponent } from './DateWidgetComponent';
import {
  DateWidgetConfigComponent,
  dateInputConfigValidator,
} from './DateWidgetConfigComponent';
import { getWidgetDateFormat, type IDateWidget } from './IDateWidget';

export const DateWidgetType: IWidgetType<IDateWidget> = {
  type: WidgetType.Date,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  name: 'Campo data',
  icon: <CalendarOutlined />,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Date),
  formComponent: DateWidgetComponent,
  createFormSchema: ({ widget }) => {
    const format = getWidgetDateFormat(widget);

    // TODO al momento i gli input impostano null all'onClear, dando problemi di validazione ai campi opzionali (non nullabili di default).
    // Utilizzare gli undefined come valori per l'onClear on sembra immediato a causa della gestione dei valori negli input di antd.
    // LA: Non possiamo usare undefined come valore di default perché verrebbe interpretato come "valore non impostato" e quindi
    // partono ad esempio i valori di default
    return createCommonFormSchema(
      yup.string().stringDate(format.serializeFormat).notRequired(),
      widget,
    );
  },
  previewComponent: DateWidgetComponent,
  configValidator: dateInputConfigValidator,
  configComponent: DateWidgetConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, DateRangeRule, CustomWarningsRule],
  hydrate: context => {
    const path = getWidgetPath(context.widget, context.context.prefix);
    const value = get(context.context.values, path);
    const format = getWidgetDateFormat(context.widget);

    return {
      value: value ? dayjs(value).format(format.datePickerFormat) : null,
    };
  },
};
